import { z } from 'zod';

/**
 * Projekt endgültig löschen (Admin, Wunsch 2026-10-12, ADR 0114). Nur für
 * archivierte Projekte. Projekt-interne Daten werden gelöscht; Belege,
 * Bestellungen, Zeitbuchungen und Lagerbewegungen bleiben und verlieren nur
 * den Projektbezug („gelöst").
 */
export const projectPurgeLineSchema = z.object({
  /** Was mit den Datensätzen passiert. */
  action: z.enum(['delete', 'detach']),
  /** Deutsche Bezeichnung im Plural, z. B. „Zeitbuchungen". */
  label: z.string(),
  count: z.number().int().nonnegative(),
});
export type ProjectPurgeLine = z.infer<typeof projectPurgeLineSchema>;

export const projectPurgePreviewSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  /** Nur Zeilen mit count > 0. */
  lines: z.array(projectPurgeLineSchema),
});
export type ProjectPurgePreview = z.infer<typeof projectPurgePreviewSchema>;

export const purgeProjectSchema = z.object({
  /** Projekt-Code, zur Bestätigung abgetippt — der Server prüft ihn erneut. */
  confirmCode: z.string().trim().min(1, 'Projekt-Code eingeben.'),
});
export type PurgeProjectInput = z.infer<typeof purgeProjectSchema>;

/** Zeile nur, wenn es etwas zu tun gibt — die Vorschau listet keine Nullen. */
export function projectPurgeLine(action: ProjectPurgeLine['action'], label: string, count: number): ProjectPurgeLine[] {
  return count > 0 ? [{ action, label, count }] : [];
}
